"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var picCap_1 = require("./picCap");
var picList_1 = require("./picList");
var contextManage_1 = require("../../contextManage");
var gpyUtils_1 = require("./gpyUtils");
// 通用高拍仪对话框组件
var CommGpy = function (props) {
    var _a = react_1.useState([]), gpyPicList = _a[0], setGpyPicList = _a[1]; //通用高拍仪右侧确定的图片列表
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    react_1.useEffect(function () {
        context.setWidth(props.width);
        context.setHeight(props.height);
        //componentWillUnmount 关闭设备
        return function () { return __awaiter(_this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!props.gpyInstance) return [3 /*break*/, 2];
                        return [4 /*yield*/, gpyUtils_1.stopDevice(props.gpyInstance)];
                    case 1:
                        res = _a.sent();
                        console.log("stop res: ", res);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    }, []);
    //确定/提交按钮事件
    var okHanlder = function () {
        //规范统一输出
        context.success({ pics: gpyPicList });
        context.closeDialog();
    };
    //关闭按钮
    var closeHandler = function () {
        if (gpyPicList.length === 0) {
            context.closeDialog();
            return;
        }
        next_1.Dialog.confirm({
            title: "提示",
            content: "确定关闭对话框？",
            draggable: true,
            onOk: function () {
                context.closeDialog();
            },
            onCancel: function () {
                return;
            },
        });
    };
    return (React.createElement("div", { className: "lobby_gpy_dialog_wap" },
        React.createElement("div", { className: "gpy_overlay_body" },
            React.createElement("div", { className: "left" },
                React.createElement(picCap_1.default, { gpyTotal: props.gpyTotal, gpyPicList: gpyPicList, setGpyPicList: setGpyPicList, gpyInstance: props.gpyInstance })),
            React.createElement(picList_1.default, { gpyTotal: props.gpyTotal, gpyPicList: gpyPicList, setGpyPicList: setGpyPicList })),
        React.createElement("div", { className: "gpy_overlay_footer" },
            React.createElement(next_1.Button, { type: "primary", onClick: okHanlder, className: "mr10", disabled: gpyPicList.length === 0 }, "\u63D0\u4EA4"),
            React.createElement(next_1.Button, { type: "normal", onClick: closeHandler, className: "mr10" }, "\u53D6\u6D88"))));
};
exports.default = CommGpy;
